module.exports = {
	"id": "ME",
	"name": "Montenegro",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": 0.006047,
			"7": null,
			"8": 0.024188,
			"9": 0.006047,
			"10": 0.06047,
			"11": 0.048376,
			"12": 0.006047,
			"13": null,
			"14": 0.012094,
			"15": null,
			"16": 0.006047,
			"17": null,
			"18": 0.084658,
			"19": null,
			"20": 0.048376,
			"21": null,
			"22": 0.108846,
			"23": 0.012094,
			"24": 0.012094,
			"25": 0.024188,
			"26": 0.096752,
			"27": 0.018141,
			"28": null,
			"29": 0.012094,
			"30": 0.018141,
			"31": 0.126987,
			"32": 0.018141,
			"33": 0.042329,
			"34": 0.114893,
			"35": 0.012094,
			"36": 0.030235,
			"37": 0.024188,
			"38": 0.090705,
			"39": 0.108846,
			"40": 0.157222,
			"41": 0.024188,
			"42": 0.030235,
			"43": 0.126987,
			"44": 0.078611,
			"45": 0.072564,
			"46": 0.048376,
			"47": 0.18141,
			"48": 0.084658,
			"49": 3.851939,
			"50": 0.102799,
			"51": 0.393055,
			"52": 0.326538,
			"53": 27.852482,
			"54": 7.613173,
			"55": 0.187457,
			"56": 0.042329,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.042329,
			"4": 0.006047,
			"5": 0.012094,
			"6": null,
			"7": null,
			"8": 0.012094,
			"9": null,
			"10": 0.024188,
			"11": null,
			"12": 0.012094,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.078611,
			"19": null,
			"20": null,
			"21": null,
			"22": 0.012094,
			"23": 0.006047,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": 0.006047,
			"31": 0.012094,
			"32": null,
			"33": 0.012094,
			"34": 0.036282,
			"35": 0.018141,
			"36": 0.018141,
			"37": 0.036282,
			"38": 0.030235,
			"39": 0.036282,
			"40": 0.036282,
			"41": 0.024188,
			"42": 0.030235,
			"43": 0.133034,
			"44": 0.036282,
			"45": 0.102799,
			"46": 0.054423,
			"47": 0.48376,
			"48": 0.308397,
			"49": 6.911721,
			"50": 0.344679,
			"51": 0.012094,
			"52": 0.012094,
			"3.5": 0.024188,
			"3.6": 0.030235
		},
		"opera": {
			"9": null,
			"11": null,
			"12": 0.018141,
			"15": null,
			"16": null,
			"17": 0.012094,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": 0.006047,
			"28": 0.012094,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": 0.012094,
			"35": 0.006047,
			"36": 0.114893,
			"37": 0.036282,
			"38": 0.012094,
			"39": 0.018141,
			"40": 1.39081,
			"41": 0.211645,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": 0.018141,
			"12.1": 0.223739
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.036282,
			"6": 0.012094,
			"7": 0.012094,
			"8": 0.030235,
			"9": 0.036282,
			"10": 0.253974,
			"3.1": null,
			"3.2": null,
			"5.1": 0.024188,
			"6.1": 0.012094,
			"7.1": null,
			"9.1": 0.205598
		},
		"ios_saf": {
			"8": 0,
			"10": 3.95880936303,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.106685331495,
			"8.1-8.4": 0.197096629371,
			"9.0-9.2": 0.0940277497918,
			"9.3": 1.43452592631
		},
		"android": {
			"3": 0,
			"4": 0.0732888242894,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00916110303618,
			"4.1": 0.264363259044,
			"4.2-4.3": 0.66090814761,
			"4.4": 1.51550818798,
			"4.4.3-4.4.4": 1.52859547804
		},
		"ie": {
			"6": 0.0184474358108,
			"7": 0.0122982905405,
			"8": 0.301308118243,
			"9": 0.104535469595,
			"10": 0.0799388885135,
			"11": 1.3036187973,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0801471449631,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.00222630958231
		},
		"edge": {
			"12": 0.042329,
			"13": 0.169316,
			"14": 0.393055
		},
		"ie_mob": {
			"10": 0.0982125633803,
			"11": 0.39986543662
		},
		"bb": {
			"7": 0.011859,
			"10": null
		},
		"samsung": {
			"0": 3.996483
		},
		"and_uc": {
			"0": 0.142308
		},
		"op_mini": {
			"0": 1.07980854545
		},
		"and_chr": {
			"0": 26.577547
		},
		"and_ff": {
			"0": 0.011859
		}
	},
	"total": 98.685984
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/ME.json
 ** module id = 585
 ** module chunks = 0
 **/